import { Tooltip as TooltipPrimitive } from "radix-ui";

interface VisibilityTooltipProps extends React.ComponentProps<typeof TooltipPrimitive.Content> {
  children: React.ReactNode;
  content: string;
}

const VisibilityTooltip = ({ children, content, ...props }: VisibilityTooltipProps) => {
  return (
    <TooltipPrimitive.Root delayDuration={0}>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          side="bottom"
          sideOffset={5}
          align="end"
          className="bg-line-btn text-g-100 py-[2px] px-[5px] rounded-[3px] text-[11px] leading-[140%] font-medium z-[1000] whitespace-pre-wrap text-right"
          {...props}
        >
          {content}
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  );
};

export default VisibilityTooltip;
